export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  author: string;
  date: string;
  views: number;
  likes: number;
}

export const articles: Article[] = [
  {
    slug: 'tsunade-senju-portrait-illustration-collection-2025',
    title: '纲手姬绝美肖像插画精选集',
    excerpt: '收录2025年度最受好评的纲手角色肖像插画作品，涵盖多种绘画风格与表现手法，展现五代目火影的独特魅力与坚韧气质。',
    content: `<p>纲手作为木叶忍者村的第五代火影，以其强大的医疗忍术、惊人的怪力以及标志性的百豪之术在火影忍者中留下了不可磨灭的印记。她的角色塑造丰满而深刻——既是战场上令敌人闻风丧胆的"三忍"之一，又是面对亲人离世后重拾信念的坚强女性。</p>
    <p>本期精选集聚焦于纲手角色的肖像插画创作，收录了来自中日韩三国优秀同人画师的作品。这些作品从不同角度诠释了纲手的多面性：有的着重表现她作为火影的威严与担当，有的捕捉她日常中不经意流露的温柔，还有的则以夸张的艺术手法展现她战斗时的英姿。</p>
    <p>在风格上，从细腻写实的厚涂风格到清新明快的赛璐璐风格，从传统日式浮世绘风格的致敬之作到现代时尚插画风格，每一幅作品都凝聚了画师对纲手这一角色的深刻理解与热爱。</p>
    <p>特别值得一提的是，本次精选集中还收录了几位新锐画师的处女作，他们以全新的视角重新诠释了纲手的形象，为这位经典角色注入了新的生命力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20style%20portrait%20of%20a%20strong%20beautiful%20female%20ninja%20character%20with%20blonde%20hair%20in%20ponytails%2C%20diamond%20mark%20on%20forehead%2C%20wearing%20green%20haori%20coat%2C%20warm%20golden%20lighting%2C%20artistic%20digital%20painting%20with%20soft%20brush%20strokes%2C%20elegant%20composition%20on%20simple%20warm%20background&width=800&height=600&seq=tsunade-cover-01&orientation=landscape',
    category: '插画',
    categorySlug: 'illustration',
    tags: ['纲手', '肖像插画', '精选集', '五代目火影'],
    author: '木叶绘馆',
    date: '2025-12-15',
    views: 12850,
    likes: 2340,
  },
  {
    slug: 'legendary-sannin-tsunade-epic-battle-doujin',
    title: '传说三忍·纲手激战同人漫画',
    excerpt: '以纲手在忍界大战中的经典战斗为蓝本，精心绘制的长篇同人漫画，重现纲手与宇智波斑的巅峰对决场景。',
    content: `<p>第四次忍界大战是火影忍者中最宏大、最激烈的篇章之一。在这场决定忍者世界命运的战争中，纲手作为五影之一，与宇智波斑展开了惊心动魄的对决。本篇同人漫画正是以这场战斗为核心，通过精心编排的分镜和细腻的笔触，将这段史诗级的战斗重新呈现在读者面前。</p>
    <p>漫画从纲手面对斑时的那份决然开始，她释放阴封印、开启百豪之术的瞬间被刻画得极具张力——查克拉如火焰般在她周身涌动，脸上的咒印纹路蔓延开来，象征着她赌上一切的觉悟。</p>
    <p>战斗场景的描绘是本作的亮点之一。画师在分镜设计上借鉴了岸本齐史老师的经典构图手法，同时又融入了自己的独特风格。每一个动作、每一次忍术的释放都充满了力量感与速度感，让读者仿佛身临其境。</p>
    <p>除了激烈的战斗场面，本作还深入挖掘了纲手的内心世界。在与斑的对峙中，她想起了自己的弟弟绳树、恋人断，以及她发誓要守护的木叶村和同伴们。这些回忆片段穿插在战斗间隙，使得整个故事的情感层次更加丰富。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20manga%20art%20style%20action%20scene%20of%20a%20powerful%20female%20ninja%20warrior%20with%20blonde%20hair%20releasing%20chakra%20energy%2C%20dramatic%20ink%20brush%20effects%2C%20intense%20battle%20composition%20with%20speed%20lines%2C%20warm%20amber%20and%20crimson%20color%20scheme%2C%20epic%20digital%20manga%20illustration&width=800&height=600&seq=tsunade-cover-02&orientation=landscape',
    category: '漫画',
    categorySlug: 'manga',
    tags: ['纲手', '同人漫画', '忍界大战', '宇智波斑', '百豪之术'],
    author: '忍绘社',
    date: '2025-11-28',
    views: 18920,
    likes: 3560,
  },
  {
    slug: 'konoha-hospital-tsunade-daily-life-fan-story',
    title: '木叶病院·纲手日常同人故事',
    excerpt: '一篇温暖治愈的同人小说，讲述纲手在木叶病院中的日常点滴，展现她作为医疗忍者与火影的双重身份下的柔软一面。',
    content: `<p>清晨的阳光透过木叶病院二楼的窗户洒进来，纲手揉了揉因为熬夜批阅文件而有些酸涩的眼睛。作为火影，公文总是堆积如山，但她依然坚持每周至少来病院三次——这里是她作为医疗忍者的根。</p>
    <p>"纲手大人！三号病房的小樱已经可以开始复健训练了。"静音抱着一摞病历本走进来，脸上带着欣慰的笑容。</p>
    <p>纲手点点头，嘴角浮现出一丝不易察觉的微笑。她的弟子春野樱，如今已经成为能够独当一面的优秀医疗忍者。看着后辈的成长，对她来说是最大的慰藉。</p>
    <p>走在病院的走廊上，纲手与每一位遇到的病人点头致意。尽管她是高高在上的火影，但在病院里，她始终保持着那份医者的温柔。一位腿部受伤的下忍怯生生地向她问好，她蹲下身子，轻轻检查了包扎的绷带，又叮嘱了几句注意事项。</p>
    <p>午后的阳光变得更加温暖。纲手站在病院的天台上，俯瞰着木叶村的景象。远处的火影岩上，历代火影的面容在阳光下熠熠生辉，而她的面容也终将刻在那里。但此刻，她只想享受这片刻的宁静——没有战争，没有伤亡，只有和平的木叶和需要她守护的人们。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20anime%20illustration%20style%20peaceful%20scene%20of%20a%20kind%20female%20character%20with%20blonde%20hair%20in%20a%20traditional%20Japanese%20hospital%20setting%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20gentle%20healing%20atmosphere%2C%20soft%20pastel%20warm%20tones%2C%20cozy%20and%20heartwarming%20digital%20art&width=800&height=600&seq=tsunade-cover-03&orientation=landscape',
    category: '同人故事',
    categorySlug: 'story',
    tags: ['纲手', '同人小说', '日常', '木叶病院', '治愈'],
    author: '木叶文学社',
    date: '2025-11-10',
    views: 8760,
    likes: 1890,
  },
  {
    slug: 'tsunade-byakugou-seal-ultimate-technique-artbook',
    title: '百豪之术·纲手终极奥义设定画集',
    excerpt: '深度解析纲手百豪之术与阴封印的视觉设定，包含多角度忍术效果分解图与创作过程分享，同人画师必备参考素材。',
    content: `<p>百豪之术——纲手独创的S级医疗禁术，也是她作为"传说中的三忍"之一的招牌奥义。这项术式通过长年将查克拉储存在额头菱形印记（阴封印）中，在解放时获得超速再生与恐怖的力量增幅。</p>
    <p>本设定画集从视觉设计的角度，对百豪之术进行了全方位的解构分析。我们邀请了五位资深同人画师，各自分享他们在描绘这一经典忍术时的独特心得与技法。</p>
    <p>第一章聚焦于阴封印的视觉演变。从纲手幼年时期额头的初始印记，到成年后完整的菱形图案，再到解放时蔓延全身的咒印纹路——每一个阶段的设计细节都被仔细拆解，包括纹路的走向、颜色的渐变、以及查克拉流动的视觉效果。</p>
    <p>第二章则深入探讨百豪之术解放瞬间的视觉表现。如何在静态画面中表现出查克拉爆发的动态感？如何处理咒印在皮肤上蔓延的纹理？多位画师分享了他们各自使用的笔刷技法、图层叠加技巧以及色彩搭配方案。</p>
    <p>第三章收录了十个完整的百豪之术场景再现案例，从线稿到成品的完整过程展示，为同人创作者提供了极具价值的参考素材。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20detailed%20close-up%20of%20a%20female%20character%20with%20diamond-shaped%20purple%20mark%20on%20forehead%20and%20flowing%20energy%20seal%20markings%20spreading%20across%20face%2C%20ethereal%20chakra%20glow%20effect%2C%20dramatic%20lighting%2C%20detailed%20texture%20rendering%2C%20digital%20art%20masterpiece&width=800&height=600&seq=tsunade-cover-04&orientation=landscape',
    category: '插画',
    categorySlug: 'illustration',
    tags: ['纲手', '百豪之术', '设定画集', '阴封印', '忍术解析'],
    author: '忍术研究社',
    date: '2025-10-22',
    views: 15630,
    likes: 2980,
  },
  {
    slug: 'tsunade-vs-orochimaru-sannin-deadlock-manga',
    title: '三忍对决·纲手VS大蛇丸经典重现',
    excerpt: '还原火影忍者经典篇章——三忍 deadlock 场景，纲手、自来也、大蛇丸三人对峙的传奇场面，同人漫画倾力再现。',
    content: `<p>木叶崩溃计划之后，纲手、自来也、大蛇丸三位传说中的忍者在一处荒野中对峙——这便是火影忍者中最经典的"三忍 deadlock"场景。三人的通灵兽——蛞蝓、蛤蟆文太、万蛇各自盘踞一方，空气中弥漫着令人窒息的紧张感。</p>
    <p>本篇同人漫画以极其精细的画风还原了这一传奇场景。画师在构图时特别注重三人空间关系的呈现——纲手立于蛞蝓之上，双手握拳，眼神中既有愤怒也有决绝；自来也站在蛤蟆文太头顶，表情少有的严肃；大蛇丸则阴冷地笑着，仿佛一切尽在掌控。</p>
    <p>在色彩运用上，画师巧妙地使用三人各自的主题色来区分阵营：纲手的绿色查克拉代表生命与治愈，自来也的蓝色查克拉象征正直与守护，大蛇丸的紫色查克拉则暗示着诡秘与危险。三种色彩在画面中交织碰撞，形成了极具视觉冲击力的效果。</p>
    <p>漫画还特别刻画了纲手克服恐血症的心路历程——从最初面对鲜血时的恐惧颤抖，到为了守护重要之人而突破心理障碍的勇气。这一段的心理描写格外细腻，让读者能够深切感受到纲手内心的挣扎与成长。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20style%20three-way%20standoff%20scene%20with%20three%20legendary%20ninja%20characters%20and%20giant%20summoned%20creatures%20slug%20toad%20snake%2C%20dramatic%20composition%2C%20wind-blown%20landscape%2C%20intense%20atmosphere%2C%20Japanese%20ink%20painting%20influenced%20digital%20art&width=800&height=600&seq=tsunade-cover-05&orientation=landscape',
    category: '漫画',
    categorySlug: 'manga',
    tags: ['纲手', '三忍', '大蛇丸', '自来也', '经典重现'],
    author: '传说绘卷',
    date: '2025-10-05',
    views: 21340,
    likes: 4120,
  },
  {
    slug: 'gambling-legend-tsunade-humorous-comic-strip',
    title: '传说中的大肥羊·纲手赌场趣事四格漫画',
    excerpt: '轻松搞笑的四格漫画系列，讲述纲手在各地赌场中"逢赌必输"的有趣经历，搭配静音的无奈吐槽，笑点满满。',
    content: `<p>在火影忍者中，纲手有一个响彻忍界的绰号——"传说中的大肥羊"。这个称号并非源于她的战斗力，而是因为她那令人瞠目结舌的赌运——逢赌必输，从未赢过。这一设定为本是同人创作提供了绝佳的喜剧素材。</p>
    <p>本系列四格漫画以纲手的赌场冒险为主线，通过轻松幽默的笔触展现了这位五代目火影不为人知的可爱一面。每一则漫画都围绕着一个独立的搞笑场景展开，从纲手自信满满地走进赌场，到输光所有钱后被静音拖走，套路虽经典，但笑果从不打折。</p>
    <p>第一话《必勝の策》中，纲手信誓旦旦地宣称自己找到了必胜的赌博方法，结果却是——把骰子捏碎，然后说"你看，我赢了，因为没有点数比我大"。静音在一旁的表情管理堪称经典。</p>
    <p>第三话《火影の威厳》中，纲手试图用自己的火影身份来震慑赌场老板，结果被老板一句"火影大人，您上次欠的账还没还呢"直接击沉。</p>
    <p>画风方面，本系列采用了更加夸张可爱的Q版造型，与严肃的正剧向同人形成鲜明反差，让读者在欢笑中感受纲手角色的另一面魅力。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20illustration%20style%20humorous%20scene%20of%20a%20blonde%20female%20character%20in%20green%20coat%20looking%20frustrated%20at%20a%20gambling%20table%20with%20dice%20and%20cards%2C%20comical%20expression%2C%20bright%20warm%20colors%2C%20lighthearted%20digital%20art%20with%20simple%20clean%20composition&width=800&height=600&seq=tsunade-cover-06&orientation=landscape',
    category: '漫画',
    categorySlug: 'manga',
    tags: ['纲手', '四格漫画', '搞笑', '赌场', '静音'],
    author: '笑忍堂',
    date: '2025-09-18',
    views: 24560,
    likes: 5280,
  },
  {
    slug: 'tsunade-and-sakura-master-student-bond-story',
    title: '师与徒·纲手与春野樱的羁绊物语',
    excerpt: '一篇感人至深的同人故事，细腻描绘纲手与弟子春野樱之间从师徒到如母女般的深厚情感，催泪治愈之作。',
    content: `<p>三年前，当春野樱第一次站在纲手面前请求收为弟子时，纲手从她眼中看到了一种熟悉的光芒——那是对强大的渴望，也是想要守护重要之人的决心。就像当年的自己。</p>
    <p>训练是艰苦的。樱的手掌因为反复练习查克拉控制而起了一层又一层的茧，但她从未抱怨过。纲手看到了这个女孩身上惊人的天赋和更加惊人的毅力。渐渐地，她开始将更多的东西教给樱——不仅仅是医疗忍术，还有她独创的怪力，以及那招被视为禁术的百豪之术。</p>
    <p>"纲手大人，我……我真的能学会吗？"樱看着自己额头上的菱形印记，声音有些颤抖。</p>
    <p>"你是我见过最有天赋的医疗忍者。"纲手伸手轻抚樱的头发，罕见地露出了温柔的笑容，"比我当年还要强。相信自己，樱。"</p>
    <p>那一刻，樱的眼泪夺眶而出。不是因为疼痛，也不是因为辛苦，而是因为纲手那句"比我当年还要强"——这是她听过的最高的赞美。</p>
    <p>在第四次忍界大战中，当樱释放百豪之术，与鸣人和佐助并肩作战时，纲手站在远处，眼中满是骄傲。她的弟子，已经真正成长为能够独当一面的优秀忍者。这一刻，她想起了自己的弟弟绳树，想起了恋人断——如果他们在天有灵，也一定会为她感到欣慰吧。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20style%20emotional%20scene%20of%20two%20female%20ninja%20characters%20one%20with%20blonde%20hair%20and%20one%20with%20pink%20hair%20sharing%20a%20warm%20moment%20under%20cherry%20blossom%20tree%2C%20soft%20sunlight%2C%20touching%20atmosphere%2C%20pastel%20warm%20color%20palette%2C%20heartfelt%20digital%20illustration&width=800&height=600&seq=tsunade-cover-07&orientation=landscape',
    category: '同人故事',
    categorySlug: 'story',
    tags: ['纲手', '春野樱', '师徒', '羁绊', '治愈'],
    author: '樱色书坊',
    date: '2025-09-01',
    views: 14320,
    likes: 3240,
  },
  {
    slug: 'tsunade-hokage-office-political-drama-doujin',
    title: '火影办公室·纲手政务风云同人漫画',
    excerpt: '以纲手担任五代目火影期间的政务工作为背景的政治剧情向同人漫画，展现忍者世界中的权力博弈与智慧较量。',
    content: `<p>成为火影意味着什么？对纲手而言，这不仅仅是拥有最强战斗力的称号，更是承担起整个木叶村安危与未来的责任。每天面对堆积如山的文件、大名府的无理要求、"根"组织的暗中活动，以及各村之间微妙的外交平衡——这些才是火影真正的战场。</p>
    <p>本篇同人漫画另辟蹊径，不聚焦于纲手的战斗场面，而是将她置于政治博弈的漩涡中心。故事以水之国雾隐村提出的新同盟条约为引子，纲手不得不在大名、顾问团、各忍者家族之间周旋，同时还要应对"根"组织在暗处的蠢蠢欲动。</p>
    <p>画风上，本篇采用了更加写实成熟的风格。人物面部表情的细微变化、肢体语言的克制表达，都服务于政治剧情的张力营造。会议室中那些看似平静的对视，实则暗流涌动——这是另一种形式的"忍术对决"。</p>
    <p>特别值得一提的是对纲手决策过程的刻画：她既不是一味强硬，也不是委曲求全，而是展现出一位成熟政治家应有的智慧与手腕。她知道何时该亮出拳头，何时该露出微笑——这两者之间微妙的平衡，恰恰是纲手作为火影最迷人的地方。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Sophisticated%20anime%20art%20style%20scene%20of%20a%20mature%20female%20leader%20with%20blonde%20hair%20sitting%20in%20a%20traditional%20Japanese%20office%20with%20scrolls%20and%20documents%2C%20serious%20expression%2C%20warm%20lighting%20from%20paper%20lantern%2C%20political%20drama%20atmosphere%2C%20detailed%20digital%20painting%20with%20rich%20textures&width=800&height=600&seq=tsunade-cover-08&orientation=landscape',
    category: '漫画',
    categorySlug: 'manga',
    tags: ['纲手', '火影办公室', '政治', '五代目火影', '剧情向'],
    author: '暗部出版社',
    date: '2025-08-15',
    views: 9870,
    likes: 1980,
  },
  {
    slug: 'summer-festival-tsunade-yukata-fan-art',
    title: '夏日祭·纲手浴衣主题插画特辑',
    excerpt: '以夏日祭典为主题的纲手角色插画合集，收录多位画师创作的浴衣纲手作品，展现纲手在传统节日中的别样风情。',
    content: `<p>每年夏季的木叶夏日祭，是整个村子最热闹的时节。街道两旁挂满了彩色灯笼，空气中弥漫着章鱼烧和苹果糖的甜香，夜空中的烟花将人们的笑脸映照得格外温暖。在这样的节日氛围中，即使是平日里威严的纲手大人，也会换上美丽的浴衣，享受难得的悠闲时光。</p>
    <p>本期插画特辑以"夏日祭·纲手"为主题，邀请十二位同人画师以各自的风格描绘纲手在夏日祭中的美丽瞬间。每一幅作品都围绕着一个特定的祭典元素展开——有的捕捉纲手手持团扇、在灯笼下回眸的惊鸿一瞥；有的描绘她在烟花绽放的夜空下仰望的侧影；还有的则聚焦于她品尝章鱼烧时难得一见的放松表情。</p>
    <p>画师"樱吹雪"的作品《灯影》尤为出色——画面中纲手身着淡绿色的浴衣，上面绣着精致的椿花纹样，她站在一排红色灯笼前，暖黄色的灯光映照在她的侧脸上，让平日里凌厉的面部线条变得格外柔和。这幅作品在发布后迅速获得了超过五千次的转发，成为当月最受欢迎的同人插画之一。</p>
    <p>除了浴衣主题外，本期还收录了一系列以夏日祭小游戏为背景的趣味插画——纲手挑战捞金鱼却屡屡失败的样子，与静音一起放烟花的温馨场景，以及她在许愿签上写下"世界和平"时专注的表情。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20style%20festival%20scene%20of%20a%20blonde%20female%20character%20in%20elegant%20green%20yukata%20kimono%20with%20flower%20patterns%2C%20standing%20under%20colorful%20paper%20lanterns%20at%20night%2C%20warm%20golden%20lighting%2C%20romantic%20summer%20festival%20atmosphere%2C%20exquisite%20digital%20illustration&width=800&height=600&seq=tsunade-cover-09&orientation=landscape',
    category: '插画',
    categorySlug: 'illustration',
    tags: ['纲手', '浴衣', '夏日祭', '插画特辑', '祭典'],
    author: '祭绘堂',
    date: '2025-08-01',
    views: 16780,
    likes: 3780,
  },
];

export const categories = [
  { name: '全部作品', slug: 'all', icon: 'ri-apps-line', count: articles.length },
  { name: '插画', slug: 'illustration', icon: 'ri-image-line', count: articles.filter(a => a.categorySlug === 'illustration').length },
  { name: '漫画', slug: 'manga', icon: 'ri-book-open-line', count: articles.filter(a => a.categorySlug === 'manga').length },
  { name: '同人故事', slug: 'story', icon: 'ri-quill-pen-line', count: articles.filter(a => a.categorySlug === 'story').length },
];

export const faqs = [
  {
    question: '纲手本子是什么？',
    answer: '纲手本子是火影忍者同人创作中以纲手角色为主题的二次创作作品合集，涵盖插画、漫画、同人小说等多种形式，由同人爱好者创作，展现纲手角色的多面魅力。',
  },
  {
    question: '本网站的内容多久更新一次？',
    answer: '我们每周至少更新一次内容，包括新增同人作品推荐、画师专访以及纲手角色的深度解析文章。遇到特殊节日或火影忍者相关纪念日时，还会推出特别企划专题。',
  },
  {
    question: '如何向本站推荐或投稿纲手同人作品？',
    answer: '欢迎通过"关于我们"页面的联系表单向我们推荐优秀的纲手同人作品或自荐投稿。我们会认真审阅每一份推荐，优质作品将有机会被收录进精选推荐列表。',
  },
  {
    question: '网站上的作品是否有版权问题？',
    answer: '本网站仅做同人创作作品的收录与推荐，所有作品版权归原作者所有。我们严格遵守同人创作社区的规范，标注作者署名与来源。如您是原作者且不希望作品被收录，请联系我们进行下架处理。',
  },
  {
    question: '纲手本子适合哪些人群阅读？',
    answer: '本网站收录的内容面向所有火影忍者粉丝，特别是喜爱纲手角色的观众。我们严格筛选内容质量，确保所有收录作品均为全年龄向的高质量同人创作，适合各年龄段火影粉丝欣赏。',
  },
  {
    question: '如何在手机端浏览本网站？',
    answer: '本网站采用响应式设计，自动适配手机、平板和电脑等各种设备。您可以在任何设备上获得良好的浏览体验，随时随地欣赏纲手同人创作。',
  },
];